import { camelCase, get, mapValues } from 'lodash';
import { Permissoes } from '../@types';
import ACTIONS_PERMISSION from '../utils/permissoes';
import usePermissoesStore from './permissoes-store';

type RawPermissoesMap = {
  [key: string | number]: string[];
};

const ROLE_MAP = {
  '204': 'contagem',
  '207': 'ocorrencia',
  '208': 'recomendacao',
  '220': 'recomendacaoSemeadura',
  '210': 'anotacao',
  '209': 'pulverizacao',
  '211': 'tarefa',
  '212': 'estoque',
  '216': 'ocorrenciaComMaquinas',
  '218': 'demarcacaoArea',
  '231': 'correcaoSolo',
  '234': 'adubacao',
  '226': 'registroDeSemeadura',
  '219': 'clima',
  '241': 'usosMaquinas',
  '245': 'mapas',
  '267': 'mapasDeCalor',
};

const getPermissoes = (): Permissoes => {
  const userPermissoes = usePermissoesStore.getState().permissions;

  const rawPermissoesMap = userPermissoes.reduce<RawPermissoesMap>(
    (mapa, { id, acoes }) => {
      const key = get(ROLE_MAP, id, camelCase(id));
      mapa[key] = acoes.map((acao) => camelCase(acao));
      return mapa;
    },
    {},
  );

  return mapValues(ACTIONS_PERMISSION, (actions, key) =>
    actions.reduce((actionsAcumulador, action) => {
      actionsAcumulador[action] = !!rawPermissoesMap[key]?.includes(action);
      return actionsAcumulador;
    }, {} as any),
  ) as Permissoes;
};

export default new Proxy({} as Permissoes, {
  get(_target, prop) {
    return getPermissoes()[prop as keyof Permissoes];
  },
});
